export default "__VITE_ASSET__dq_Am4_w__"